gsap.registerPlugin(ScrollTrigger);
/* aos */

document.addEventListener("DOMContentLoaded", function () {
  AOS.init({
    startEvent: "DOMContentLoaded",
    offset: 100,
    once: true,
  });
  setTimeout(function () {
    if (AOS) {
      AOS.refresh();
    }
  }, 1000);
});
class SlideshowCarousel extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this;
    this.slideshow = this.querySelector(".slideshow__swiper");
    this.prevBtn = this.querySelector(".slideshow__btn-prev");
    this.nextBtn = this.querySelector(".slideshow__btn-next");
    this.thumbs = this.querySelector(".slideshow__thumbs");

    this.init();
    this.cursorArrow();
  }

  init() {
    let slideshowSwiper;
    let thumbsSwiper;
    if (!this.slideshow) {
      return;
    }

    const paginationNumber = this.querySelector(
      ".slideshow__pagination-number"
    );

    const paginaitonProgress = this.querySelector(
      ".slideshow__pagination-progress"
    );
    const duration = this.slideshow.getAttribute("data-duration");
    const countSlides = this.querySelectorAll(".slideshow__slide").length;

    // console.log(paginationNumber);
    //   console.log(duration);
    //   console.log(countSlides);

    if (this.thumbs) {
      // let slidesPerView990 = countSlides < 4 ? countSlides : 4;
      // let slidesPerView750 = countSlides < 4 ? slidesPerView990 : 3;
      // let slidesPerView576 = countSlides < 3 ? slidesPerView750 : 2;
      // let slidesPerView = countSlides < 2 ? slidesPerView576 : 1.8;
      let slidesPerView = Math.min(countSlides, 4);
      let swiperThumbsParams = {
        slidesPerView: slidesPerView,
        spaceBetween: 8,
        autoplay: false,
        breakpoints: {
          576: {
            slidesPerView: Math.min(countSlides, 3),
            spaceBetween: 20,
          },
          750: {
            slidesPerView: Math.min(countSlides, 3),
            spaceBetween: 20,
          },
          990: {
            slidesPerView: Math.min(countSlides, 4),
            spaceBetween: 20,
          },
        },
        on: {
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
      };
      // console.log("Slides per view for thumbs:", slidesPerView);
      // console.log("Swiper params for slideshow:", swiperThumbsParams);
      thumbsSwiper = new Swiper(this.thumbs, swiperThumbsParams);
    }

    let swiperParams = {
      draggable: true,
      speed: 700,
      autoHeight: false,
      allowTouchMove: true,
      // effect: "fade",
      // fadeEffect: {
      //   crossFade: true,
      // },
      on: {
        // slideChange() {
        //   console.log("playVideo");
        // },
      },
    };

    if (this.slideshow.getAttribute("data-pagination") === "true") {
      const paginationType = this.slideshow.getAttribute(
        "data-pagination-type"
      );
      switch (paginationType) {
        case "bullets":
          // console.log("bullets");
          swiperParams.pagination = {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
          };
          break;
        case "numbers":
          // console.log("numbers");
          swiperParams.pagination = {
            el: ".slideshow__pagination-number",
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<span class="' +
                className +
                '"><svg width="48" height="48" viewBox="0 0 48 48" fill="none"><circle class="circle" style="animation-duration: ' +
                duration / 1000 +
                's" cx="24" cy="24" r="22" stroke="currentColor"/></svg><span class="fluid-h6 color-white">' +
                (index + 1) +
                "</span></span>"
              );
            },
          };
          swiperParams.on = {
            slideChange() {
              if (
                paginationNumber &&
                paginationNumber.querySelector(
                  ".swiper-pagination-bullet-active .circle"
                )
              ) {
                paginationNumber.querySelector(
                  ".swiper-pagination-bullet-active .circle"
                ).style.animationPlayState = "running";
                // playVideo(slideshow);
              }
            },
          };
          break;

        case "progress":
          swiperParams.pagination = {
            el: ".slideshow__pagination-progress",
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<div class="' +
                className +
                '"><span class="slideshow__nav-item-progress-bar"><span class="slideshow__nav-item-progress"></span></span></div>'
              );
            },
          };

          break;
        case "tabs":
          // console.log("tabs"); //tabs
          swiperParams.thumbs = {
            swiper: thumbsSwiper,
          };

          // if (thumbsSwiper) {
          //   thumbsSwiper.on("click", (swiper) => {
          //     if (slideshowSwiper) {
          //       console.log("Thumb clicked:", swiper.clickedIndex);
          //       slideshowSwiper.slideTo(swiper.clickedIndex);
          //     }
          //   });
          // }
          break;
      }
    }

    if (this.slideshow.getAttribute("data-navigation") === "true") {
      swiperParams.navigation = {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      };
    }

    if (this.slideshow.getAttribute("data-effect-fade") === "true") {
      swiperParams.effect = "fade";
      swiperParams.fadeEffect = {
        crossFade: true,
      };
    }

    if (this.slideshow.getAttribute("data-autoplay") === "true") {
      swiperParams.autoplay = {
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      
      };
    }
    
    if (this.slideshow.getAttribute("data-loop") === "true") {
         swiperParams.loop = true;
         swiperParams.loopPreventSliding = false;
    }
    
    slideshowSwiper = new Swiper(this.slideshow, swiperParams);
  }

  cursorArrow() {
    const cursorArrow = this.wrapper.querySelector(".cursor-arrow-left");
    // console.log(cursorArrow);

    if (cursorArrow) {
      const w = cursorArrow.offsetWidth / 2;
      let x = 0;
      let y = 0;

      if (this.slideshow && window.innerWidth > 768) {
        this.slideshow.addEventListener("mouseenter", () => {
          cursorArrow.style.transition = "opacity 200ms";
          cursorArrow.style.opacity = "1";
        });

        this.slideshow.addEventListener("mouseleave", () => {
          cursorArrow.style.transition = "opacity 200ms";
          cursorArrow.style.opacity = "0";
        });

        this.wrapper.addEventListener("mousemove", (event) => {
          x = event.clientX;
          y = event.clientY;

          let rect = this.wrapper.getBoundingClientRect();
          let objRect = this.slideshow.getBoundingClientRect();

          cursorArrow.style.position = "absolute";
          cursorArrow.style.display = "block";
          cursorArrow.style.left = x - w - rect.left + "px";
          cursorArrow.style.top = y - (rect.top - window.scrollY) - w + "px";

          if (x > objRect.left + objRect.width / 2) {
            cursorArrow.classList.add("on");
          } else {
            cursorArrow.classList.remove("on");
          }
        });
      }
    }
  }
}

customElements.define("slideshow-carousel", SlideshowCarousel);

/* faq */
(function () {
  const initfaqContent = () => {
    $(".faq-content-toggle")
      .unbind("click")
      .on("click", function () {
        const parent = $(this).parent();

        if (!parent.hasClass("active")) {
          parent.siblings(".faq-content-item.active").removeClass("active");
          parent.addClass("active");
          $(this)
            .closest(".faq-content-wrapper")
            .find(".faq-content-answer")
            .stop()
            .slideUp(600);
          $(this).next().stop().slideDown(300);
        } else {
          parent.siblings(".faq-content-item.active").removeClass("active");
          parent
            .closest(".faq-content-wrapper")
            .find(".faq-content-answer")
            .stop()
            .slideUp(300);
          parent.removeClass("active");
          $(this).next().stop().slideUp(300);
        }
      });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initfaqContent();
  });
})();
function HiAddClass(obj1, obj2, nNum, sClass, bOnce) {
  if (obj1.length !== 0) {
    obj2.forEach(function (element) {
      let a = true;
      let b = true;

      function fn1() {
        // const scrollTop = window.pageYOffset;
        const scrollTop = window.scrollY;
        const obj1Top = obj1.getBoundingClientRect().top + scrollTop;
        const obj1Height = obj1.offsetHeight;
        const windowHeight = window.innerHeight;

        if (b) {
          if (
            scrollTop > obj1Top - windowHeight + windowHeight * nNum &&
            scrollTop < obj1Top + obj1Height
          ) {
            if (a) {
              a = false;
              if (bOnce) {
                b = false;
              }
              element.classList.add(sClass);
            }
          } else {
            a = true;
            element.classList.remove(sClass);
          }
        }
      }

      window.addEventListener("scroll", fn1);
      fn1(); // Initial check
    });
  }
}

document.querySelectorAll(".font-run").forEach(function (el) {
  HiAddClass(el, [el], 0, "on", true);
});

document.querySelectorAll(".font-reveal").forEach(function (el) {
  HiAddClass(el, [el], 0, "on", true);
});

/*  */

/* clip-path-reveal-animation */
// console.log(Dom.body);
// console.log(Dom.is_iOs);

const initializeMediaReveals = () => {
  const mediaEls = document.querySelectorAll(".media-reveal-animation");

  if (mediaEls) {
    mediaEls.forEach((el) => {
      if (!el.mediaRevealInitialized) {
        el.mediaRevealInitialized = true;

        ScrollTrigger.create({
          trigger: el,
          start: "center bottom",
          end: "center top",
          invalidateOnRefresh: true,
          onEnter: () => {
            if (!el.classList.contains("animated")) {
              el.classList.add("animated");
            }
          },
          inEnterBack: () => {
            if (!el.classList.contains("animated")) {
              el.classList.add("animated");
            }
          },
        });
      }
    });
  }
};

// InitBackgroundTransitions();
initializeMediaReveals();


/*  */

class Modal extends HTMLElement {
  constructor() {
    super();
    this.body = document.querySelector("body");
    this.popup = null; // 子类定义
    this.popup_close = null; // 子类定义
    this.background_overlay = document.querySelector(".background-overlay");
  }

  initPopup() {
    this.initPopupContent();
    this.bindCloseEvents(); // 绑定关闭事件
  }

  bindCloseEvents() {
    const closeElems = [this.popup, this.popup_close, this.background_overlay];

    closeElems.forEach((closeElem) => {
      closeElem.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        // 点击空白区域或关闭按钮时关闭弹窗
        if (!this.popup_content.contains(e.target)) {
          this.closePopup();
        }
      });
    });
  }

  closePopup() {
    this.body.classList.remove("is-show");
    if (this.popup) {
      this.popup.classList.remove("is-show");
    }
  }

  backgroundOverlayHoverEffect() {
    const backgroundOverlay = document.querySelector(".background-overlay");
    const backgroundCursorWrapper = backgroundOverlay.firstElementChild;

    if (backgroundOverlay || backgroundCursorWrapper) {
      const enlargeCursor = () => {
        backgroundCursorWrapper.classList.add("enlarge-cursor");
      };

      const dwindleCursor = () => {
        backgroundCursorWrapper.classList.remove("enlarge-cursor");
      };

      const setCursorPosition = (clientX, clientY) => {
        requestAnimationFrame(() => {
          backgroundCursorWrapper.style.setProperty("--translate-x", clientX);
          backgroundCursorWrapper.style.setProperty("--translate-y", clientY);
        });
      };

      const handleMouseMove = (e) => {
        setCursorPosition(e.clientX, e.clientY);
      };

      const handleMouseEnter = (e) => {
        setCursorPosition(e.clientX, e.clientY);
        enlargeCursor();
      };

      const handleMouseLeave = (e) => {
        setCursorPosition(e.clientX, e.clientY);
        backgroundCursorWrapper.removeEventListener(
          "mousemove",
          handleMouseMove
        );
        dwindleCursor();
      };

      backgroundOverlay.addEventListener("mouseenter", handleMouseEnter);
      backgroundOverlay.addEventListener("mouseleave", handleMouseLeave);
      backgroundOverlay.addEventListener("mousemove", handleMouseMove);
      backgroundOverlay.addEventListener("click", dwindleCursor);
    }
  }
}

class CommonModal extends Modal {
  constructor() {
    super();
    this.modal = this;
    this.popup = document.querySelector("#common-modal-popup");
    this.popup_close = document.querySelector("[data-close-common-popup]");
    this.popup_content = this.popup.querySelector(".popup-content");
    this.initPopup();
    this.backgroundOverlayHoverEffect();
  }

  initPopupContent() {
    this.modal.addEventListener("click", () => {
      const title = this.querySelector(".modal-title");
      const content = this.querySelector(".common-modal-content");

      if (!content) return;

      this.popup.classList.add("is-show");
      this.popup.querySelector(".popup-title").textContent = title.textContent;
      this.popup.querySelector(".popup-content").innerHTML = content.innerHTML;
      this.body.classList.add("is-common-modal");
    });
  }

  closePopup() {
    this.body.classList.remove("is-common-modal");
    if (this.popup) {
      this.popup.classList.remove("is-show");
    }
  }
}

customElements.define("common-modal", CommonModal);

class VideoModal extends Modal {
  constructor() {
    super();
    this.modal = this.querySelector(".video-modal-popup");
    this.popup = document.querySelector("[data-popup-video]");
    this.popup_content = this.popup.querySelector(".popup-content");
    this.popup_close = this.popup.querySelector(".popup-close");
    this.triggers = this.querySelectorAll("[data-type][data-src]");
    this.initPopup();
    this.backgroundOverlayHoverEffect(); // 启用鼠标跟随效果
  }

  initPopupContent() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();

        const aspect_ratio = trigger.getAttribute("aspect-ratio") || "56.3%";
        const video_type = trigger.getAttribute("data-type");
        const video_src = trigger.getAttribute("data-src");

        if (video_type && video_src) {
          const $content = `<div class="fluid-width-video-wrapper" style="padding-top: ${aspect_ratio}">
                              ${
                                video_type === "youtube"
                                  ? `<iframe
                                      id="player"
                                      type="text/html"
                                      width="100%"
                                      frameborder="0"
                                      webkitAllowFullScreen
                                      mozallowfullscreen
                                      allowFullScreen
                                      src="https://www.youtube.com/embed/${video_src}?autoplay=1&mute=1">
                                    </iframe>`
                                  : `<iframe 
                                      src="https://player.vimeo.com/video/${video_src}?autoplay=1&mute=1" 
                                      class="js-vimeo" 
                                      allow="autoplay; 
                                      encrypted-media" 
                                      webkitallowfullscreen 
                                      mozallowfullscreen 
                                      allowfullscreen">
                                    </iframe>`
                              }
                            </div>`;

          this.popup_content.innerHTML = $content;
          this.popup.classList.add("is-show");
          this.body.classList.add("video-dialog-show");
        }
      });
    });
  }

  closePopup() {
    this.body.classList.remove("video-dialog-show");

    const iframe = this.popup_content.querySelector("iframe");
    if (iframe) {
      iframe.remove();
    }

    super.closePopup();
  }
}

customElements.define("video-modal", VideoModal);


/* media-carousel */

var VMediaCarousel = new Swiper(".v-media-carousel", {
  threshold: 5,
  slidesPerView: 1,
  effect: "fade",
  on: {
    activeIndexChange: imageCarouselIndexChange,
  },
  keyboard: {
    enabled: !0,
    onlyInViewport: !0,
  },
  breakpoints: {
    768: {},
  },
});

var VMediaCopyCarousel = new Swiper(".v-media-copy-carousel", {
  threshold: 5,
  slidesPerView: 1,
  pagination: {
    el: "#progress-bar-equipment-workout-mobile",
    type: "progressbar",
  },
  on: {
    activeIndexChange: copyCarouselIndexChange,
    init: copyCarouselInit,
    // sliderFirstMove: pauseProgressBars,
    // slideResetTransitionEnd: setProgressBars,
    autoplayStart: (e) => {
      // setProgressSelector1779(e), setProgressBars(e);
      setProgressSelector1779(e);
    },
  },
  keyboard: {
    enabled: !0,
    onlyInViewport: !0,
  },
  breakpoints: {
    768: {},
  },
});

window.VMediaCopyCarouselController = {
  next: () => {
    workoutEquipmentCopyCarousel.slideNext();
  },
  prev: () => {
    workoutEquipmentCopyCarousel.slidePrev();
  },
};

function imageCarouselIndexChange(e) {
  VMediaCopyCarousel.slideTo(e.realIndex);
}

function copyCarouselIndexChange(e) {
  setCount(e), VMediaCarousel.slideTo(e.realIndex), setProgressSelector1779(e);
  // setProgressBars(e);
}

function copyCarouselInit(e) {
  // carouselSwiperObserver.observe(e.el),
  setProgressSelector1779(e),
    // setProgressBars(e),
    e.wrapperEl.parentElement.parentElement.parentElement.parentElement
      .querySelectorAll(".carousel-button")
      .forEach((e, t) => {
        e.addEventListener("click", () => {
          VMediaCopyCarousel.slideTo(t);
        });
      });
}

function setProgressSelector1779(e) {
  let t = e.activeIndex,
    i = e.wrapperEl.parentElement.parentElement.parentElement.parentElement,
    o = i.querySelector(".progress-bar-track");
  o.classList.remove("active"),
    o.offsetWidth,
    o.classList.add("active"),
    i.querySelectorAll(".carousel-button").forEach((e, i) => {
      i === t ? e.classList.add("active") : e.classList.remove("active");
    });
}

// function setProgressBars(e) {
//   let t = e.activeIndex;
//   e.wrapperEl.parentElement.parentElement
//     .querySelectorAll(".progress-bar")
//     .forEach((e, i) => {
//       e.classList.remove("pauseAnim"),
//         i === t ? e.classList.add("active") : e.classList.remove("active");
//     });
// }

// function pauseProgressBars(e) {
//   let t =
//       e.wrapperEl.parentElement.parentElement.querySelectorAll(".progress-bar"),
//     i = e.activeIndex;
//   t.forEach((e, t) => {
//     t === i && e.classList.add("pauseAnim");
//   });
// }

// function setVerticalListProgress(e) {
//   e.activeIndex;
//   let t =
//     e.wrapperEl.parentElement.parentElement.parentElement.parentElement.querySelector(
//       ".vertical-progress-bar-items"
//     ).children;
//   t.length,
//     Array.from(t).forEach((t, i) => {
//       i === e.realIndex
//         ? t.classList.add("active")
//         : t.classList.remove("active");
//     });

//   // console.log(t);
//   // console.log(t.length);
// }

function setVerticalListProgress(e) {
  // console.log(e.wrapperEl);
  // Get all list items under the 'vertical-progress-bar-items' class
  const listItems = e.wrapperEl
    .closest(".t-media-box-wapper")
    .nextElementSibling.querySelector(".vertical-progress-bar-items").children;

  // Loop through all list items and update the 'active' class
  Array.from(listItems).forEach((item, index) => {
    if (index === e.realIndex) {
      item.classList.add("active");
    } else {
      item.classList.remove("active");
    }
  });

  // Debugging logs
  // console.log(listItems);
  // console.log(listItems.length);
}

function setCount(e) {
  let t = e.realIndex;
  e.wrapperEl
    .closest(".carousel-w-count")
    .querySelector(".count-position").innerHTML =
    t + 1 >= 10 ? t + 1 : "0" + (t + 1);
}

/* testimonials slider */
(() => {
  const initSlider = () => {
    let testimonialsSlider = document.querySelector(".testimonials__slider");

    if (testimonialsSlider) {
      let navigation = document.querySelector(".testimonials__navigation");
      let pagination = document.querySelector(".testimonials__pagination");

      const columns = Number(testimonialsSlider.dataset.columns);
      console.log(columns);

      let columns750;
      if (columns > 1) columns750 = columns - 1;
      else columns750 = columns;

      let swiperParams = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        breakpoints: {
          750: {
            slidesPerView: columns750,
            slidesPerGroup: columns750,
          },
          1200: {
            slidesPerView: columns,
            slidesPerGroup: columns,
          },
        },
      };

      if (testimonialsSlider.getAttribute("data-pagination") === "true") {
        swiperParams.pagination = {
          el: pagination,
          type: "bullets",
          clickable: true,
        };
      }

      if (testimonialsSlider.getAttribute("data-navigation") === "true") {
        swiperParams.navigation = {
          nextEl: navigation.querySelector(".swiper-button-next"),
          prevEl: navigation.querySelector(".swiper-button-prev"),
        };
      }

      const testimonialsSwiper = new Swiper(testimonialsSlider, swiperParams);
    }
  };

  initSlider();
})();

/* splash-video */

// document.addEventListener("DOMContentLoaded", function () {
//   let imgElement = document.querySelector(".splash-video__meida-wrapper");
//   let cn3Element = document.querySelector(".splash-video-section.cn3");

//   if (imgElement && cn3Element) {
//     console.log(window.innerHeight)
//     gsap.to(imgElement, {
//       width: "100%",
//       borderRadius: "0px",
//       ease: "none",
//       scrollTrigger: {
//         trigger: cn3Element,
//         start: "top center",
//         end: "+=" + window.innerHeight / 2,
//         scrub: true,
//       },
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  let imgElement = document.querySelector(".splash-video__meida-wrapper");
  let cn3Element = document.querySelector(".splash-video-section.cn3");

  if (imgElement && cn3Element) {
    // 预先设置初始状态
    gsap.set(imgElement, { width: "84.1%" });

    gsap.to(imgElement, {
      width: "100%",
      borderRadius: "0px",
      ease: "none",
      scrollTrigger: {
        trigger: cn3Element,
        start: "top center",
        end: "+=" + window.innerHeight / 2,
        scrub: true,
      },
    });
  }
});

const initMarqueeDesktop = () => {
  let testimonialsMarquee = document.querySelectorAll(".testimonials__marquee");

  if (testimonialsMarquee.length !== 0) {
    testimonialsMarquee.forEach((slider) => {
      const slides = slider.querySelectorAll(".swiper-slide");

      // 监听 Slide 内容的变化
      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          const slide = entry.target;
          slide.style.height = "auto"; // 让高度由内容决定
        });
      });

      // 监听每个 Slide 的内容
      slides.forEach((slide) => {
        resizeObserver.observe(slide);
      });

      // 计算总高度
      let sum = 0;
      slides.forEach((slide) => {
        sum += slide.clientHeight + 24; // 24px 是 spaceBetween
      });

      sum -= 24; // 减去最后一个 spaceBetween

      // 克隆 Slide 直到总高度足够
      if (slides.length > 0) {
        let i = 0;
        while (sum < slider.clientHeight * 2) {
          if (i > slides.length - 1) {
            i = 0;
          }

          let clone = slides[i].cloneNode(true);
          slider.querySelector(".swiper-wrapper").appendChild(clone);
          sum += clone.clientHeight + 24; // 24px 是 spaceBetween
          i++;
        }
      }

      // 初始化 Swiper
      const testimonialsMarqueeSlider = new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 24,
        direction: "vertical",
        loop: true,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        autoplay: {
          delay: 1,
        },
        freeMode: true,
        speed: 15000,
      });
    });
  }
};

initMarqueeDesktop();

/*  */
const ymm_title = document.querySelector("#ymm_label");

if (ymm_title) {
  ymm_title.classList.add("font-neuropol");
}

